import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//components
import StatisticsInfo from './StatisticsInfo';
import MoneyAmountInfo from './MoneyAmountInfo';

const Statistics: FC = () => {
	return (
		<Box>
			<StatisticsInfo />
			<MoneyAmountInfo />
		</Box>
	);
};

export default Statistics;
